import React, { useEffect, useContext, useState } from 'react';

import { useIntl } from 'react-intl';

import { Grid, useMediaQuery, useTheme } from '@material-ui/core';

import PageHeader from 'pages/breakout/components/PageHeader';
import translations from 'utils/translations';
import { BookingUser } from 'components/BookingForm';
import { useNetwork } from 'services/network';
import InfoDialog from './Dialog/InfoDialog';
import { LoaderContext } from 'context/LoaderContextProvider';
import { SdmSpacer, SdmTypography } from 'components';
import { theme } from 'theme';
import { getBrand } from 'entities/agenda/agendaHelper';
import { backHomeLink } from 'utils/constants';

const ExhibitorBooking = ({ user, locale }) => {
  //Hooks
  const intl = useIntl();
  const i18n = translations.Agenda(intl).forms;
  const network = useNetwork();
  const { setLoaderActive, isLoaderActive } = useContext(LoaderContext);
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  // States
  const [infoDialog, setInfoDialog] = useState({
    isOpen: false,
    isError: false,
  });
  const [fetchedUser, setFetchedUser] = useState();
  const [fetchedBrand, setFetchedBrand] = useState();
  const [hasVisits, setHasVisits] = useState(false);
  const [customError, setCustomError] = useState(false);
  // Functions
  useEffect(() => {
    const fetchUser = async (id) => {
      showLoader();
      try {
        const promises = [];
        const input = {
          userSalesforceId: user.salId,
        };
        promises.push(network.agendaLambda(input, '/user'));
        if (!fetchedBrand && id) {
          promises.push(network.exhibitorGet(id));
          promises.push(
            getBrand({
              id: id,
            })
          );
          const res = await Promise.all(promises);
          const _user = res[0];
          setFetchedUser(_user);
          const brand = res[1];
          const exhibitorData = res[2];
          const _hasVisits = !!exhibitorData?.visits?.items?.length;
          setHasVisits(_hasVisits);
          if (brand) {
            setFetchedBrand({ ...brand, data: exhibitorData });
          }
        } else {
          fetchedBrand({});
        }
        setCustomError(false);
      } catch (error) {
        console.log('LOG::  ~ error', error);
        setCustomError(true);
      } finally {
        hideLoader();
      }
    };

    const params = new URLSearchParams(location.search);
    const brandId = params.get('salesforce_id');
    if (user && user.salId && brandId) fetchUser(brandId);
    else setCustomError(true);
  }, [user]);

  // Functions
  const handleBack = () => {
    const params = new URLSearchParams(location.search);
    const brandId = params.get('salesforce_id');
    window.location.href = `${backHomeLink}/${locale}/exhibitors${
      brandId ? '?salesforce_id=' + brandId : ''
    }`;
  };
  const handleSubmit = async (data) => {
    let error = true;
    showLoader();
    try {
      const input = {
        brandName: fetchedBrand.nomeEspositore,
        brandSalesforceId: fetchedBrand.accountId,
        // TODO: change this after deploy
        brandEmail: fetchedBrand.email,
        userSalesforceId: user.salId,
        slotId: data.time.value,
        language: data.language.value,
        phone: data.phone,
        company: data.company,
        reason: data.reason,
        stand: fetchedBrand.stand || 'N.A.',
        pavillion: fetchedBrand.hall || 'N.A.',
      };
      const res = await network.agendaLambda(input, '/create');
      error = res.error;
    } catch (error) {
      console.error('LOG::  ~ error', error);
    } finally {
      hideLoader();
      setInfoDialog({ isOpen: true, isError: error });
    }
  };

  // Renders
  const renderInfoDialog = () => {
    if (!infoDialog.isOpen) return null;
    return (
      <InfoDialog
        onClose={() => {
          // setInfoDialog({ isOpen: false, isError: false });
          window.location.href = `${backHomeLink}/${locale}/exhibitors`;
        }}
        i18n={i18n.user}
        isSmDown={isSmDown}
        isError={infoDialog.isError}
      />
    );
  };
  return (
    <Grid container>
      <div style={{ width: '100%' }}>
        {renderInfoDialog()}
        <div style={{ width: '90%', margin: '0 auto', maxWidth: 1250 }}>
          <PageHeader
            i18n={i18n.user}
            isBrandPage={false}
            hasBackBtn={true}
            onBack={handleBack}
          />
          {!isLoaderActive ? (
            <>
              {!hasVisits ? (
                <>
                  <SdmSpacer height={50} />
                  <SdmTypography
                    variant="pageSubtitle"
                    textAlign="center"
                    style={{
                      color: customError
                        ? theme.colors.primary.red
                        : theme.colors.primary.black,
                    }}
                  >
                    {customError
                      ? i18n.error
                      : fetchedBrand
                      ? `${fetchedBrand.nomeEspositore} ${i18n.noVisits}`
                      : null}
                  </SdmTypography>
                </>
              ) : (
                <>
                  {user.type !== 'Operator' ? (
                    <>
                      <SdmSpacer height={50} />
                      <SdmTypography variant="pageSubtitle" textAlign="center">
                        {i18n.notOperator}
                      </SdmTypography>
                    </>
                  ) : (
                    <>
                      {fetchedBrand && fetchedUser && !customError ? (
                        <BookingUser
                          exhibitor={fetchedBrand}
                          user={user}
                          fetchedUser={
                            fetchedUser?.accountid !== '000'
                              ? fetchedUser
                              : false
                          }
                          onBack={handleBack}
                          onSubmit={handleSubmit}
                        />
                      ) : (
                        <>
                          <SdmSpacer height={50} />
                          <SdmTypography
                            variant="pageSubtitle"
                            textAlign="center"
                            style={{ color: theme.colors.primary.red }}
                          >
                            {i18n.error}
                          </SdmTypography>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          ) : null}
        </div>
      </div>
    </Grid>
  );
};
export default ExhibitorBooking;
